import PolicyDoc from "@/components/PolicyDoc";
import { EFFECTIVE_DATE, intro, sections } from "@/privacyData";

export default function PrivacyPolicy() {
  return (
    <PolicyDoc
      docTitle="Privacy Policy"
      pageTitle="Privacy Policy \u2014 GrowCalc"
      effectiveDate={EFFECTIVE_DATE}
      intro={intro}
      sections={sections}
      contactNumber={10}
    />
  );
}
